interface TwoColumnBlockProps {
  content: {
    imageUrl?: string;
    text?: string;
    title?: string;
    reversed?: boolean;
  };
}

export function TwoColumnBlock({ content }: TwoColumnBlockProps) {
  return (
    <section className="mx-auto max-w-[1200px] px-6 py-16">
      <div
        className={`grid grid-cols-1 md:grid-cols-2 gap-12 items-center ${
          content.reversed ? "direction-rtl" : ""
        }`}
        style={content.reversed ? { direction: "rtl" } : undefined}
      >
        <div style={content.reversed ? { direction: "ltr" } : undefined}>
          {content.imageUrl && (
            <img
              src={content.imageUrl}
              alt={content.title || ""}
              className="w-full object-cover"
            />
          )}
        </div>
        <div style={content.reversed ? { direction: "ltr" } : undefined}>
          {content.title && (
            <h3 className="font-serif text-2xl text-foreground mb-4">
              {content.title}
            </h3>
          )}
          {content.text && (
            <p className="font-sans text-base leading-relaxed text-muted-foreground whitespace-pre-line">
              {content.text}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
